import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = {
  style: {"z-index":"99999"},
  class: "\n      position-absolute\n      bg-primary\n      vw-100\n      vh-100\n      d-flex\n      flex-column\n      align-items-center\n      justify-content-center\n    "
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  width: "300",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_spinner, { class: "mt-4" })
  ]))
}